import React from 'react';

const AppointmentSection = (props) => {
    return (
        <section className={"" + props.hclass}>
            <h1 className="d-none">title</h1>
            <div className="container">
                <div className="wrapper">
                    <div className="appointment-content">
                        <h2>Book your next visit in just a moment</h2>
                        <p>
                            We care about your time and your health. Call us, message us, or visit our front
                            desk and our friendly team will schedule the perfect time for you. Early morning,
                            late evening, or weekend appointments – we’ll do our best to match your routine.
                        </p>
                        <p>
                            Emergencies are always prioritized. If you or your loved ones need urgent medical
                            attention, please contact us immediately so we can prepare and assist you without delay.
                        </p>
                        <p className="appointment-highlight">
                            Your wellbeing starts with a conversation. Reach out today and take the first step
                            toward better health with us.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AppointmentSection;